export default __webpack_public_path__ + "13913d02af020d456a1c7b4bd6d1dcac.png";